import { BreakpointsOptions } from '@mui/system';

export const breakpoints: BreakpointsOptions = {
  values: {
    xs: 320,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920,
  },
};
